import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { map, Observable } from 'rxjs';
import { AssetsService } from '../../services';

const DEFAULT_LOADING_WIDTH = '120px';

@Component({
  selector: 'app-secondary-loading-animation',
  templateUrl: './secondary-loading-animation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SecondaryLoadingAnimationComponent implements OnInit {
  @HostBinding('class')
  private get classes(): string {
    return `w-full flex flex-col items-center justify-center ${this.hostHeightClass}`;
  }

  options$: Observable<AnimationOptions>;

  @Input()
  height: string;

  @Input()
  hostHeightClass = 'h-full';

  @Input()
  width = DEFAULT_LOADING_WIDTH;

  constructor(private assetsService: AssetsService) {}

  ngOnInit(): void {
    this.options$ = this.assetsService.getSecondaryLoadingAnimation().pipe(
      map((animationData) => ({
        animationData,
      })),
    );
  }
}
